import { render, staticRenderFns } from "./PriceRecordsEdit.vue?vue&type=template&id=44e59775&"
import script from "./PriceRecordsEdit.vue?vue&type=script&lang=js&"
export * from "./PriceRecordsEdit.vue?vue&type=script&lang=js&"
import style0 from "./PriceRecordsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports